/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { defineAsyncComponent } from 'vue';

import { type App } from '~/app';

export default (app: App) => {

    app.vueApp.component('offers-carousel', defineAsyncComponent(async () => import("./OffersCarousel.vue")));
}


